import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseRepository} from "./base/base.repository";
import { PostPayloadInterface } from '../models/post-payload.interface';

@Injectable({
    providedIn: 'root'
})
export class ProductRepository extends BaseRepository {
    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.path = 'dashboard/admin/products';
    }

    getAllForRestaurant(restaurantHistoryId: number) {
        const path = 'webapi/api/products/filter/'+restaurantHistoryId;
        return super.get(path);
    }

    publish(id: number) {
        const path = this.path + '/' + id + '/publish';
        return super.patch(path);
    }

    revoke(id: number) {
        const path = this.path + '/' + id + '/revoke';
        return super.patch(path);
    }

    patchToRestaurantHistory(payload: PostPayloadInterface) {
        const path = this.path + '/' + payload.id + '/restaurants';
        return super.patch(path, payload);
    }
}
